module.exports = __webpack_public_path__ + "static/media/OURS.0f8950e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Skew/img/OURS.png
// module id = 302
// module chunks = 0